module.exports = __webpack_public_path__ + "img/u12.e9555620.svg";